import { useContext } from 'react';
import { createContext } from 'react';

import { MenuProps, OrientationProps } from '../@types/MenuProps';

export const MenuContext = createContext<MenuProps>({} as MenuProps);

MenuContext.displayName = 'Menu';

type ProviderProps = {
	children: JSX.Element[];
	props: MenuProps;
};

type OrientationProviderProps = {
	children?: JSX.Element;
	orientation?: OrientationProps;
};

const MenuProvider = ({ children, props }: ProviderProps) => (
	<MenuContext.Provider value={props}>{children}</MenuContext.Provider>
);

export const useMenuItem = () => {
	const context = useContext(MenuContext);

	return context;
};

const OrientationContext = createContext<OrientationProviderProps>({} as OrientationProviderProps);

export const OrientationProvider = (props: OrientationProviderProps) => (
	<OrientationContext.Provider value={props}>{props.children}</OrientationContext.Provider>
);

export const useOrientation = () => {
	const context = useContext(OrientationContext);

	return context;
};

export default MenuProvider;
